/* ==========================================================================
   Vildblad 2.5 – kakrutan, rätt variant och bild i förslagen, Komplettera
   ========================================================================== */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const V = () => window.Vildblad || {};

  const money = (cents) => {
    const n = Number(cents) / 100;
    const whole = Math.abs(n % 1) < 0.005;
    return n.toLocaleString('sv-SE', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }) + ' kr';
  };

  /* ---------- Byt bild när kunden väljer färg (förslag i varukorgen och Komplettera) ---------- */
  const swapImage = (img, url) => {
    if (!img || !url) return;
    const next = url.replace(/^\/\//, 'https://');
    if (img.currentSrc === next || img.src === next) return;
    img.classList.add('is-swapping');
    const pre = new Image();
    pre.onload = pre.onerror = () => {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = next;
      img.classList.remove('is-swapping');
    };
    pre.src = next;
  };

  document.addEventListener('change', (e) => {
    const sel = e.target.closest && e.target.closest('[data-upsell-select], [data-complete-select]');
    if (!sel) return;
    const card = sel.closest('[data-upsell-card], [data-complete-item]');
    const opt = sel.selectedOptions[0];
    if (!card || !opt) return;
    const btn = $('[data-quick-add]', card);
    if (btn) btn.dataset.quickAdd = opt.value;
    const price = $('[data-upsell-price], [data-complete-price]', card);
    if (price && opt.dataset.price) price.textContent = opt.dataset.price;
    if (price && opt.dataset.cents) price.dataset.cents = opt.dataset.cents;
    swapImage($('.up-card__media img, .complete__media img', card), opt.dataset.image);
    const root = card.closest('[data-complete]');
    if (root) updateComplete(root);
  });

  /* ---------- Komplettera: summa och "Lägg till valda" ---------- */
  function updateComplete(root) {
    const items = $$('[data-complete-item]', root).filter((it) => $('[data-complete-toggle]', it)?.checked);
    const sum = items.reduce((acc, it) => acc + Number($('[data-complete-price]', it)?.dataset.cents || 0), 0);
    const out = $('[data-complete-sum]', root);
    const btn = $('[data-complete-add-all]', root);
    const label = $('[data-complete-label]', root);
    if (out) out.innerHTML = items.length ? `<span>${items.length} ${items.length === 1 ? 'vara' : 'varor'}</span> <strong>${money(sum)}</strong>` : 'Bocka i det du vill ha';
    if (btn) btn.disabled = items.length === 0;
    if (label) label.textContent = items.length > 1 ? `Lägg till ${items.length} varor` : 'Lägg i varukorgen';
  }

  const initComplete = (root) => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    updateComplete(root);
    root.addEventListener('change', (e) => { if (e.target.matches('[data-complete-toggle]')) updateComplete(root); });
    root.addEventListener('click', (e) => {
      const all = e.target.closest('[data-complete-add-all]');
      if (!all) return;
      const ids = $$('[data-complete-item]', root)
        .filter((it) => $('[data-complete-toggle]', it)?.checked)
        .map((it) => Number($('[data-quick-add]', it)?.dataset.quickAdd))
        .filter(Boolean);
      if (!ids.length) return;
      const items = ids.map((id) => ({ id, quantity: 1 }));
      const cart = V().Cart;
      if (cart && cart.add) {
        cart.add(items, { button: all }).catch(() => {});
      } else {
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) })
          .then(() => { window.location.href = '/cart'; });
      }
    });
  };
  $$('[data-complete]').forEach(initComplete);
  document.addEventListener('shopify:section:load', (e) => $$('[data-complete]', e.target).forEach(initComplete));

  /* ---------- Selfcare-guiden: lägg hela rutinen i varukorgen ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('[data-ritual-add]');
    if (!btn) return;
    const panel = btn.closest('[data-ritual]');
    const ids = $$('[data-quick-add]', panel).map((b) => Number(b.dataset.quickAdd)).filter(Boolean);
    if (!ids.length) return;
    const items = ids.map((id) => ({ id, quantity: 1 }));
    const cart = V().Cart;
    if (cart && cart.add) {
      cart.add(items, { button: btn }).catch(() => {});
    } else {
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) })
        .then(() => { window.location.href = '/cart'; });
    }
  });

  /* ---------- Kakrutan (Shopify Customer Privacy API) ---------- */
  const cc = $('[data-cc]');
  if (!cc) return;
  document.documentElement.classList.add('vb-cc');
  const html = document.documentElement;
  const prefs = $('[data-cc-prefs]', cc);
  const btnAccept = $('[data-cc-accept]', cc);
  const btnDecline = $('[data-cc-decline]', cc);
  const btnSave = $('[data-cc-save]', cc);
  const btnCustom = $('[data-cc-customize]', cc);
  const inp = { analytics: $('[data-cc-analytics]', cc), marketing: $('[data-cc-marketing]', cc), preferences: $('[data-cc-preferences]', cc) };

  const withApi = (cb) => {
    const sh = window.Shopify;
    if (sh && sh.customerPrivacy) { cb(sh.customerPrivacy); return; }
    if (!sh || typeof sh.loadFeatures !== 'function') return;
    sh.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => { if (!err && window.Shopify.customerPrivacy) cb(window.Shopify.customerPrivacy); });
  };

  const setMode = (custom) => {
    prefs.hidden = !custom;
    btnSave.hidden = !custom;
    btnAccept.hidden = custom;
    btnCustom.setAttribute('aria-expanded', String(custom));
    btnCustom.textContent = custom ? 'Tillbaka' : 'Välj själv';
  };

  const show = (custom = false) => {
    setMode(custom);
    cc.hidden = false;
    html.classList.add('cc-open');
    requestAnimationFrame(() => requestAnimationFrame(() => cc.classList.add('is-open')));
  };
  const hide = () => {
    cc.classList.remove('is-open');
    html.classList.remove('cc-open');
    setTimeout(() => { cc.hidden = true; }, 450);
  };

  // Kundens val sparas också i webbläsaren, så rutan aldrig visas igen efter ett val (ett år)
  const KEY = 'vb-consent';
  const YEAR = 365 * 24 * 3600 * 1000;
  const readStored = () => {
    try {
      const s = JSON.parse(localStorage.getItem(KEY) || 'null');
      return s && s.t && Date.now() - s.t < YEAR ? s : null;
    } catch (e) { return null; }
  };
  const writeStored = (c) => {
    try { localStorage.setItem(KEY, JSON.stringify({ analytics: !!c.analytics, marketing: !!c.marketing, preferences: !!c.preferences, t: Date.now() })); } catch (e) { /* tyst */ }
  };
  const apply = (cp, c) => {
    try {
      cp.setTrackingConsent({ analytics: c.analytics, marketing: c.marketing, preferences: c.preferences, sale_of_data: c.marketing }, () => {
        document.dispatchEvent(new CustomEvent('vildblad:consent', { detail: c }));
      });
    } catch (e) { /* tyst */ }
  };
  // Har besökaren redan svarat? I Sverige svarar API:t "no" även för den som aldrig har svarat,
  // så vi går på Shopifys samtyckeskaka (_tracking_consent) och ett uttryckligt "yes".
  const hasChoice = (cp) => {
    if (/(?:^|;\s*)_tracking_consent=/.test(document.cookie)) return true;
    try {
      if (typeof cp.getTrackingConsent === 'function' && cp.getTrackingConsent() === 'yes') return true;
    } catch (e) { /* tyst */ }
    return false;
  };

  const save = (c) => {
    writeStored(c);
    withApi((cp) => apply(cp, c));
    hide();
  };

  btnAccept.addEventListener('click', () => save({ analytics: true, marketing: true, preferences: true }));
  btnDecline.addEventListener('click', () => save({ analytics: false, marketing: false, preferences: false }));
  btnSave.addEventListener('click', () => save({ analytics: inp.analytics.checked, marketing: inp.marketing.checked, preferences: inp.preferences.checked }));
  btnCustom.addEventListener('click', () => setMode(prefs.hidden));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !cc.hidden && cc.dataset.reopened) hide(); });

  const fillFromCurrent = (cp) => {
    try {
      const cur = cp.currentVisitorConsent ? cp.currentVisitorConsent() : {};
      const st = readStored() || {};
      inp.analytics.checked = cur.analytics ? cur.analytics === 'yes' : !!st.analytics;
      inp.marketing.checked = cur.marketing ? cur.marketing === 'yes' : !!st.marketing;
      inp.preferences.checked = cur.preferences ? cur.preferences === 'yes' : !!st.preferences;
    } catch (e) { /* tyst */ }
  };

  // Visa bara när Shopify säger att besökaren behöver frågas (region och inställningar i admin)
  // OCH besökaren inte redan har gjort ett val. shouldShowBanner() svarar bara på region och inställning.
  withApi((cp) => {
    if (typeof cp.shouldShowBanner !== 'function' || !cp.shouldShowBanner()) return;
    if (hasChoice(cp)) return;
    const stored = readStored();
    if (stored) { apply(cp, stored); return; } // valet fanns bara lokalt – skicka det igen, visa inte rutan
    setTimeout(() => show(false), 700);
  });

  // "Ändra kakval" (sidan Cookies och länkar med data-cc-open) öppnar vår ruta i stället för Shopifys
  document.addEventListener('click', (e) => {
    const t = e.target.closest && e.target.closest('[data-cc-open], [data-cookie-settings]');
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    withApi((cp) => fillFromCurrent(cp));
    cc.dataset.reopened = '1';
    show(true);
  }, true);
  const wrap = $('[data-cookie-settings-wrap]');
  if (wrap) wrap.hidden = false;
})();
